import type { ReactNode } from "react"
import type { Scope } from "@/lib/connection"
import { cn } from "@/lib/utils"
import { CommandPalette } from "@/workspace/command-palette"
import { AppSidebar } from "./app-sidebar"
import { CONSOLE_PAGE_CARD } from "./ConsoleChrome"
import { ShellPageHeader, useDesktopRail } from "./page-header"
import { ShellDrawer, ShellNav } from "./shell-nav"

/** Console's canvas, transparent rail and inset page slab, with Norn scope ownership. */
export function ConsoleShell({ scope, children }: { scope: Scope; children: ReactNode }) {
  const desktop = useDesktopRail()
  return (
    <ShellNav>
      <div
        data-slot="console-chrome"
        className="console-app-shell flex h-full min-h-0 w-full bg-canvas text-foreground"
      >
        {desktop ? <AppSidebar scope={scope} /> : null}
        <CommandPalette scope={scope} />
        <ShellDrawer>
          <AppSidebar scope={scope} drawer />
        </ShellDrawer>
        <div className="flex min-h-0 min-w-0 flex-1 flex-col md:p-2 md:ps-0">
          <div
            className={cn(
              CONSOLE_PAGE_CARD,
              "flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden max-md:rounded-none max-md:border-0",
            )}
          >
            <ShellPageHeader scope={scope}>{children}</ShellPageHeader>
          </div>
        </div>
      </div>
    </ShellNav>
  )
}
